'use strict'
/**
 * This same edit dialog is used for single edits, bulk edits and group edit.
 * If the options object of the model contains a group property or bulkAction property the
 * saving of the models is threated differently.
 */
var _ = require('lodash')

var EditNewController = require('src/components/edit_new-controller.js')
var App = require('app')
var flatten = require('flat')
var DialogModel = require('src/common/dialog-model.js')

/* Views */
var View = require('./view.js')

var DeviceEdit = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region

      var clients = App.globalChannel.request('client:entities:cached')
      var device = options.device
      var devices = options.collection
      var group = options.group
      
      if (group) {
        self.deviceType = group.get('type')
        var client = clients.get(group.get('client'))
      } else if (device) {
        self.deviceType = device.get('type')
        var client = clients.get(device.get('client'))
      }

      // in case of a bulkAction get the client and device type
      if (options.bulkAction) {
        var client = clients.get(App.session.user.get('client'))

        // if the bulk collection is of one devicetype, set the devicetype
        var deviceTypes = _.uniq(_.map(devices.where({_bulk: true}), 'attributes.type'))

        if (deviceTypes.length === 1) {
          self.deviceType = deviceTypes[0]
        } else {
          self.deviceType = false
        }
      }



      // define the dialog model
      var dialogStruct = {
        title: 'device',
        buttons: {
          left: [
            { label: 'delete', icon: true, slug: 'delete', action: 'dialog:delete', roles: ['super'] },
            { label: 'save preset', icon: false, slug: 'save-preset', action: 'dialog:save-preset', roles: ['super', 'admin'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        },
        tabs: [
          { label: 'Basic', slug: 'basic', elementId: 'tab-basic', roles: [] },
          // { label: 'Sensors', slug: 'sensors', elementId: 'tab-sensor', roles: [] },
          { label: 'Properties', slug: 'properties', elementId: 'tab-properties', roles: [] },
          { label: 'Settings', slug: 'settings', elementId: 'tab-settings', roles: [] }


        ]
      }

      // rth_rhm get a seperate tab
      if (self.deviceType == 'rtm_rhm' || self.deviceType == 'rtm_rhm_mqtt') {
        dialogStruct.tabs.push(
          { label: 'Mbus', slug: 'mbus', elementId: 'tab-mbus', roles: [] }
        )
      }


      if (!group && !device && !options.bulkAction) device = App.globalChannel.request('device:entity:new')        
      // when new device remove the tabs
      if (device) {
        if (device.isNew()) delete dialogStruct.tabs
      }

      self.device = device
  
      var dialogModel = new DialogModel(dialogStruct)



      if (group) dialogModel.set({title: 'Edit devices'})

      this.view = this.getView(dialogModel, device, devices, client, self.deviceType)

   

      this.listenTo(this.view, 'childview:control:send-command', this.onSendCommand)
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'dialog:save-preset', this.onPresetName)
      this.listenTo(this.view, 'dialog:load-preset', this.onLoadPreset)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)

      this.listenTo(this.view, 'firmware:update', function() {
        console.log('ai');
      })


      this.region.show(this.view)
    },
    onSendCommand: function (data) {

      var self = this

      if (self.options.group) {
        let group = self.options.group
        return group.sendCommand(data)
      }

      let device = self.device
      device.sendCommand(data, {
        success:(value) => {
          App.dialog.notice(App.TextParser('NOTICE_COMMAND_SENT'))
        }
      })
    },
    formPreSave: function (model, data) {
      let self = this
      let groupModel = this.options.group
      let isGroupEdit = (groupModel)
      let preparedData = _.clone(data)

      // prepare geoData
      if (preparedData.geoLocation) {
        console.log('oeh')
        preparedData.geoLocation = [ preparedData.geoLocation[0],  preparedData.geoLocation[1]];
      }

      //preparedData['geoLocation'] = model.get('geoLocation')
      // handle differently based on if this is a device edit or a device group edit
      if (isGroupEdit) {
        // if the name is left blank, remove it to prevent accidentally removing the name
        if (preparedData.name === '') delete preparedData.name

        App.dialog.confirm({
          message: 'Are you sure you want to perform an operation on ' + groupModel.collection.length + ' devices in the group?',
          callback: function (confirmed) {
            if (confirmed) {
              groupModel.updateDevices(preparedData, {
                success: function () {
                  self.region.empty()
                },
                error: function () {
                  App.dialog.alert('Something went wrong while updating the devices')
                }
              })
            }
          }
        })

        // prevent the normal execution
        return false
      } else {
        console.log(preparedData)

        //preparedData['geoLocation'] = model.get('geoLocation')
        return preparedData
      }
    },
    // prepare the bulk data to be saved
    formBulkPreSave: function (model, collection, data) {
      let preparedData = _.clone(data)

      // if the name is left blank, remove it to prevent accidentally removing the name
      if (preparedData.name === '') delete preparedData.name

      return preparedData
    },
    /* Event methods --------------------------------------------------------- */
    onLoadPreset: function (view, presetId) {
      var self = this

      if (!view.options.client.get('presets')) return false

      var preset = _.find(view.options.client.get('presets'), function (o) { return o._id === presetId })

      App.dialog.confirm({
        message: App.TextParser('CONFIRM_PRESET_APPLY_DEVICE'),
        callback: function (confirmed) {
          if (confirmed) {
            view.populatePresetFields(flatten(preset.settings))
          }
        }
      })
    },
    // onSendCommand: function (data) {
    //   var self = this

    //   // if (self.options.bulkAction) {
    //   //   let bulkCollection = self.view.collection
    //   //   return bulkCollection.sendBulkCommand(data)
    //   // }

    //   // if (self.options.group) {
    //   //   let group = self.options.group
    //   //   return group.sendCommand(data)
    //   // }

    //   let device = self.device
    //   device.sendCommand(data, {
    //     success:(value) => {
    //       App.dialog.notice(App.TextParser('NOTICE_COMMAND_SENT'))
    //     }
    //   })
    // },
    onPresetName: function (view) {
      var self = this

      App.dialog.prompt({
        message: App.TextParser('PROMPT_PRESET_NAME'),
        placeholder: '',
        callback: function (value) {
          if (!value) return false

          self.onPresetSave(view, {
            'name': value
          })
        }
      })
    },
    onPresetSave: function (view, presetOptions) {
      var client = view.options.client
      var data = Backbone.Syphon.serialize(view)

      var settings = {
        'sensors': data.sensors,
        'properties': data.properties
      }

      var preset = {
        'name': presetOptions.name,
        'type': 'edit',
        'deviceType': view.options.deviceType,
        'settings': settings
      }

      // save the preset
      client.addPreset(preset, {
        success: function () {
          view.render()
          App.dialog.notice(App.TextParser('NOTICE_PRESET_SAVED'))
        },
        error: function () {
          App.dialog.alert(App.TextParser('NOTICE_SAVE_FAILED'))
        }
      })
    },
    /* Views ----------------------------------------------------------------- */
    getView: function (dialogModel, device, collection, client, deviceType) {
      return new View.Layout({
        dialogModel: dialogModel,
        model: device,
        collection: collection,
        client: client,
        deviceType: deviceType
      })
    }

  })

  return new Controller(options)
}

module.exports = DeviceEdit



// WEBPACK FOOTER //
// ./js/modules/devices/edit/index.js